export const COMPONENT_NAME = "shared-radio";
